<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import Popup from './Popup.svelte'
  import {ethers} from "ethers";

  export let show = false;
  // export let hasAlreadySubmitted;

  let dropTarget: HTMLElement;
  let predictionFiles=null;
  let over = false;

  export let stake: number;
  export let allowance: number;
  export let approvingForCompetition: boolean;
  export let submissionHash: string;
  let newStake = null;
  let newStakeFloat = null;
  // let increase: boolean;
  let difference;
  let disabled = true;
  let differenceAbsStr: string = null;

  $: {
    if (dropTarget) {
      dropTarget.ondragover = dropTarget.ondragenter = evt => {
        evt.preventDefault(); 
        over = true;
      }
      dropTarget.ondragleave = () => over = false;

      dropTarget.ondrop = function(evt) {
        over = false;
        predictionFiles = evt.dataTransfer.files;

        evt.preventDefault();
      }
    }
  }

  const dispatch = createEventDispatcher();

	function submit() {
		dispatch('submit', { predictionFile: predictionFiles ? predictionFiles[0] : null,
          stake: newStakeFloat });
      predictionFiles = null
      newStake = (newStake == 0 && submissionHash) ? newStake : null
	}

    function approve() {
        dispatch('approve', { });
    }

	function cancel() {
		dispatch('cancel');
        predictionFiles = null
        newStake = null
	}


  $: {
    try {
      let oldStakeFloat = !!stake && ethers.utils.parseUnits('' + stake, 6);
      newStakeFloat = !!newStake && ethers.utils.parseUnits('' + newStake, 6);
      if (oldStakeFloat && newStakeFloat) {
        const increase = newStakeFloat.gt(oldStakeFloat);
        difference = newStakeFloat.sub(oldStakeFloat);

        let differenceAbs = increase ? newStakeFloat.sub(oldStakeFloat) : oldStakeFloat.sub(newStakeFloat);
        differenceAbsStr = ethers.utils.formatUnits(differenceAbs, 6);
      }
      disabled = newStake === null || newStake === '' || ((newStake < 1) && (newStake != 0));
    } catch (error) {
      differenceAbsStr = null;
      disabled = true;
    }
  }

</script>

<Popup on:cancel={cancel} on:submit={submit} show={show}>
  <div>
    <h3 class="text-lg leading-6 font-medium text-gray-900">
      Please upload your prediction file (.csv)
    </h3>
    <!-- {#if !hasAlreadySubmitted}
      <h2 class="text-sm leading-6 text-red-600 font-semibold mt-1">
        After submitting your prediction you will not be able to change your stake
      </h2>
    {/if} -->
  </div>

  <div>
    <div bind:this={dropTarget}
         class="mt-3 flex justify-center px-6 pt-5 pb-6 border-2 rounded-md"
         class:border-gray-300={!predictionFiles}
         class:border-dashed={!predictionFiles}
         class:bg-indigo-200={predictionFiles}
         class:border-indigo-400={over}
         class:border-gray-400={predictionFiles}>
      <div class="space-y-1 text-center">
        <svg xmlns="http://www.w3.org/2000/svg"
             class="mx-auto h-8 w-8" 
             class:text-gray-400={!predictionFiles}
             class:text-gray-600={predictionFiles}
             fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <div class="mx-auto text-sm"
             class:text-gray-600={!predictionFiles}
             class:text-gray-800={predictionFiles}>
          <span>
            {#if predictionFiles && predictionFiles[0]}
              <span class="font-bold">{predictionFiles[0].name}</span>
            {:else}
              Prediction file
            {/if}
          </span>
        </div>
        <div class="flex text-sm text-gray-600">
          <label for="prediction-file-upload" class="relative cursor-pointer rounded-md font-medium text-indigo-600 hover:text-indigo-500">
            <span>
              Choose a file
            </span>
            <input bind:files={predictionFiles} id="prediction-file-upload" name="file-upload" type="file" accept=".csv" class="sr-only">
          </label>
          <p class="pl-1">or drag and drop</p>
        </div>
        <!-- <p class="text-xs text-gray-500">
          PNG, JPG, GIF up to 10MB
        </p> -->
      </div>
    </div>
  </div>

  <hr class="h-px my-4 bg-gray-200 border-0 dark:bg-gray-700 mx-0 px-0">

<!--  STAKING SECTION-->
  <div>
    <div>
      Current Stake: {stake}
    </div>
<!--    <div class="mt-2 text-sm text-gray-500 h-3">-->
<!--      Current Allowance: {allowance}-->
<!--    </div>-->
<!--        <div class="mt-2 text-sm text-gray-500 h-3">-->
<!--          Current Submission: {submissionHash}-->
<!--        </div>-->
    <div class="mt-3 __text-center sm:mt-5">
      <div class="mt-1 flex rounded-md shadow-sm">
        <span class="relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-l-md text-gray-700 bg-gray-50">Set to</span>
        <div class="-ml-px relative flex items-stretch flex-grow focus-within:z-10">
          <input type="text" autocomplete="off" bind:value={newStake} name="stake" id="stake" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-r-md pl-3 sm:text-sm border-gray-300" placeholder="Insert your new stake">
        </div>
      </div>
      <p class="mt-2 text-xs text-gray-500 h-3" id="email-description">
        {#if differenceAbsStr &&!disabled}
          Stake will be {newStake - stake >= 0 ? 'increased' : 'decreased'} by {Math.round(1000000 * Math.abs(newStake - stake)) / 1000000}.
          {newStake == 0 ?
                  (submissionHash ? 'Click below to first remove your submission. Then you can fully withdraw your stake.' : 'Click below to fully withdraw your stake.')
                  : ''
          }
          {#if (allowance < (newStake - stake))}
            <br>
            You will need to first approve the competition for the increased stake.
            {/if}
        {/if}
      </p>
    </div>
  </div>


<!--  END STAKING SECTION-->



    {#if newStake == 0 && submissionHash}
    <div class="mt-8 sm:mt-10">
      <button on:click={submit} type="button" disabled={disabled} class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 disabled:bg-indigo-300 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
        Remove Submission
      </button>
    </div>
    {:else if newStake == 0 && !submissionHash}
    <div class="mt-8 sm:mt-10">
      <button on:click={submit} type="button" disabled={disabled} class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 disabled:bg-indigo-300 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
        Withdraw All
      </button>
    </div>
  {:else if allowance > (newStake - stake)}
    <div class="mt-8 sm:mt-10">
      <button on:click={submit} type="button" disabled={disabled} class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 disabled:bg-indigo-300 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
        Submit
      </button>
    </div>
    {:else}
    <div class="mt-8 sm:mt-10">
      <button on:click={approve} type="button" disabled={approvingForCompetition} class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 disabled:bg-indigo-300 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
        Approve
      </button>
    </div>
    {/if}

  <div class="mt-5 sm:mt-6">
    <button on:click={cancel} type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 text-base font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
      Cancel
    </button>
  </div>
</Popup>
